var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"switch":""},model:{value:(_vm.boolValue),callback:function ($$v) {_vm.boolValue=$$v},expression:"boolValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }